// extracted by mini-css-extract-plugin
export var content = "RealEstatesMap-module--content--cd5oG";
export var contentWrapper = "RealEstatesMap-module--contentWrapper--j8VmZ";
export var icon = "RealEstatesMap-module--icon--0+Isz";
export var item = "RealEstatesMap-module--item--n-+sd";
export var map = "RealEstatesMap-module--map--lYpDh";
export var selected = "RealEstatesMap-module--selected--iQ8RL";